import moment from 'moment';

const filter = {

  rmb(value: any) {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    return '￥' + value.toFixed(2);
  },
  date(value: any) {
    return moment(value).format('YYYY-MM-DD');
  },
  formatDateDay(time: string) {
    if (!time) return '';
    return moment(time).format('YYYY-MM-DD');
  },

  formatDateSec(time: string) {
    if (!time) return '';
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  },

  formatDateMin(time: string) {
    if (!time) return '';
    return moment(time).format('YYYY-MM-DD HH:mm');
  },

  formatDateMon(time: string) {
    if (!time) return '';
    return moment(time).format('YYYY-MM');
  },

  toPercent(value: any) {
    let str = Number(value * 100).toFixed(2);
    str += '%';
    return str;
  },

  nullString(value: any) {
    if (value === null || value === undefined || value === '') {
      return '-';
    } else {
      return value;
    }
  },

  toAscll(value: any): any {
    return String.fromCharCode(value);
  }
}

export default filter;